/* eslint-disable jsx-a11y/anchor-is-valid */
import { DollarCircleOutlined, PercentageOutlined } from "@ant-design/icons";
import { uuidv4 } from "@firebase/util";
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Space,
} from "antd";
import dayjs from "dayjs";
import { collection, doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../../../firebase";

const ManagementFees = ({ data, dataId, isUpdate, companyName }) => {
  const [isShowNewManagement, setIsShowNewManagement] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [managemenEditIndex, setManagemenEditIndex] = useState("");
  const [initialValues, setInitialValues] = useState({});
  const [managementFee, setManagementFee] = useState(data);

  console.log("manageFeeeee", managementFee);

  const handleNewShowManagement = () => {
    setIsShowNewManagement(true);
    setModalOpen(false);
    setManagemenEditIndex("");
    setIsEditable(false);
    setIsWaiting(false);
  };

  const handleShowManagement = () => {
    setIsShowNewManagement(false);
    setIsEditable(false);
  };
  const handleEditModal = () => {
    const filteredFees = managementFee.find(
      (item) => item.id === managemenEditIndex
    );
    console.log("Initial values***********", filteredFees);
    setInitialValues({
      managementFeeStartDate: filteredFees?.managementFeeStartDate
        ? dayjs(filteredFees?.managementFeeStartDate, "YYYY-MM")
        : "",
      feeType: filteredFees?.feeType || "",
      waiveFeeWhenVacant: filteredFees?.waiveFeeWhenVacant || false,
      managementFee: filteredFees?.managementFee || "",
      maxManagementFee: filteredFees?.maxManagementFee || "",
      minManagementFee: filteredFees?.minManagementFee || "",
    });
    setIsShowNewManagement(true);
    setIsEditable(true);
    setModalOpen(false);
    console.log("edit index:");
    console.log(managemenEditIndex);
    setIsWaiting(false);
  };

  const editPolicy = (id) => {
    setModalOpen(true);
    setManagemenEditIndex(id);
  };

  const defaultFeesType = isEditable && data[managemenEditIndex]?.feeType;
  const [feesType, setFeesType] = useState(defaultFeesType);
  console.log(defaultFeesType);

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setFeesType(e.target.value);
  };

  const onFinish = async (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });

    const managementFees = {
      id: uuidv4(),
      managementFeeStartDate: values.managementFeeStartDate
        ? values.managementFeeStartDate.format("YYYY-MM")
        : "",
      feeType: values.feeType,
      waiveFeeWhenVacant: values.waiveFeeWhenVacant,
      managementFee: values.managementFee,
      maxManagementFee: values.maxManagementFee,
      minManagementFee: values.minManagementFee,
    };

    const newManagementFee = [...managementFee, managementFees];
    setManagementFee(newManagementFee); // Update the state with the new array

    isUpdate(true);
    setIsWaiting(true);
    setIsEditable(false);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);

      const managementFeesArray = { managementFees: newManagementFee };
      await updateDoc(propertyDocRef, managementFeesArray);

      setTimeout(() => {
        isUpdate(true);
        setIsShowNewManagement(false);
        setIsEditable(false);
        setIsWaiting(false);
      }, 4000);
    } catch (error) {
      console.error("Not updated:", error);
      setIsWaiting(false);
    }
  };

  const onFinishEdit = async (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });

    const updatedManagementFees = managementFee.map((item) => {
      if (item.id === managemenEditIndex) {
        return {
          ...item,
          managementFee: values.managementFee,
          managementFeeStartDate:
            values.managementFeeStartDate.format("YYYY-MM"),
          feeType: values.feeType,
          waiveFeeWhenVacant: values.waiveFeeWhenVacant,
          maxManagementFee: values.maxManagementFee,
          minManagementFee: values.minManagementFee,
        };
      }
      return item;
    });
    setManagementFee(updatedManagementFees);

    isUpdate(true);
    setIsWaiting(true);
    setIsEditable(false);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);

      const managementFeesArray = { managementFees: updatedManagementFees };
      await updateDoc(propertyDocRef, managementFeesArray);

      setTimeout(() => {
        setIsShowNewManagement(false);
        setIsWaiting(false);
      }, 3000);
    } catch (error) {
      console.error("Not updated:", error);
      setIsWaiting(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setIsWaiting(false);
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(false);

  const showModal = (id) => {
    setDeleteId(id);
    setDeleteModal(true);
  };

  const handleOk = async () => {
    const updatedManagementFees = managementFee.filter(
      (item) => item.id !== deleteId
    );
    setManagementFee(updatedManagementFees);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);

      const managementFeesArray = { managementFees: updatedManagementFees };
      await updateDoc(propertyDocRef, managementFeesArray);
    } catch (error) {
      console.error("Not updated:", error);
    }
    setDeleteModal(false);
  };

  const handleCancel = () => {
    setDeleteModal(false);
  };

  return (
    <div>
      <Card
        title="Management Fees"
        extra={
          <Button onClick={handleNewShowManagement}>
            <i
              className="fa-solid fa-circle-plus"
              style={{ marginRight: "5px" }}
            ></i>{" "}
            New Management Fee Policy
          </Button>
        }
      >
        {isShowNewManagement && (
          <>
            <Card>
              {isEditable ? (
                <b>Update Current Policy</b>
              ) : (
                <b>New Management Fee Policy</b>
              )}
              <Form
                name="basic"
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                style={{
                  maxWidth: 600,
                }}
                colon={false}
                initialValues={isEditable && initialValues}
                onFinish={isEditable ? onFinishEdit : onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item label="Start Date" name="managementFeeStartDate">
                  <DatePicker.MonthPicker
                    placeholder=""
                    format="YYYY-MM"
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <Form.Item
                  label="Waive Fees when Vacant"
                  name="waiveFeeWhenVacant"
                  valuePropName="checked"
                >
                  <Checkbox></Checkbox>
                </Form.Item>
                <Form.Item label="Fee Type" required name="feeType">
                  <Radio.Group onChange={onChange}>
                    <Space direction="vertical">
                      <Radio value="Percent">Percent</Radio>
                      <Radio value="Flat">Flat</Radio>
                    </Space>
                  </Radio.Group>
                </Form.Item>
                {feesType === "Flat" ? (
                  <Form.Item label="Amount" required name="managementFee">
                    <Input prefix={<DollarCircleOutlined />} />
                  </Form.Item>
                ) : (
                  <>
                    <Form.Item label="Amount" required name="managementFee">
                      <Input suffix={<PercentageOutlined />} />
                    </Form.Item>
                    <Form.Item label="Minimum" required name="minManagementFee">
                      <Input prefix={<DollarCircleOutlined />} />
                    </Form.Item>
                    <Form.Item label="Maximum" name="maxManagementFee">
                      <Input prefix={<DollarCircleOutlined />} />
                    </Form.Item>
                  </>
                )}

                <Row gutter={16}>
                  <Col>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={isWaiting}
                    >
                      {isWaiting ? "Please wait..." : "Save"}
                    </Button>
                  </Col>
                  <Col>
                    <Button onClick={handleShowManagement}>Cancel</Button>
                  </Col>
                </Row>
              </Form>
            </Card>
            <br />
          </>
        )}
        {!isEditable && (
          <>
            {managementFee?.length > 0
              ? managementFee?.map((item, index) => (
                  <Card style={{ marginBottom: "5px" }} key={index}>
                    <Form layout="vertical">
                      <Row justify="start" key={index}>
                        <Col span={8}>
                          <b>
                            {item?.managementFeeStartDate === ""
                              ? "No Start Date "
                              : item?.managementFeeStartDate}{" "}
                            -
                            {item?.managementFeeEndDate === ""
                              ? " No End Date"
                              : item?.managementFeeEndDate}
                          </b>
                          <br />
                          <br />
                          <a href="#" onClick={() => editPolicy(item.id)}>
                            Edit Current Policy
                          </a>{" "}
                          {item.id === "" ? null : (
                            <>
                              <span
                                className="onclick-red-text"
                                onClick={() => showModal(item.id)}
                              >
                                {" "}
                                Delete
                              </span>
                              <Modal
                                title="Please Confirm"
                                open={deleteModal}
                                onOk={handleOk}
                                onCancel={handleCancel}
                                okText="Delete"
                              >
                                <p>
                                  Are you sure you want to delete this policy?
                                </p>
                              </Modal>
                            </>
                          )}
                        </Col>
                        <Col span={4}>
                          <Form.Item label="Management Fee">
                            <p>
                              {item?.managementFee === ""
                                ? "--"
                                : item?.managementFee}
                              {item?.feeType === "Flat" ? "$" : "%"}
                            </p>
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item label="When Vacant">
                            <p>
                              {item?.waiveFeeWhenVacant
                                ? "Waived"
                                : "Collected"}
                            </p>
                          </Form.Item>
                        </Col>
                        {item?.feeType === "Flat" ? null : (
                          <>
                            <Col span={4}>
                              <Form.Item label="Minimum">
                                <p>
                                  {item?.minManagementFee === ""
                                    ? "--"
                                    : item?.minManagementFee}
                                </p>
                              </Form.Item>
                            </Col>
                            <Col span={4}>
                              <Form.Item label="Maximum">
                                <p>
                                  {item?.maxManagementFee === ""
                                    ? "--"
                                    : item?.maxManagementFee}
                                </p>
                              </Form.Item>
                            </Col>
                          </>
                        )}
                      </Row>
                    </Form>
                  </Card>
                ))
              : null}
          </>
        )}
      </Card>

      <Modal
        title="Choose One"
        style={{
          top: 20,
        }}
        centered
        open={modalOpen}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={() => setModalOpen(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <Button onClick={() => setModalOpen(false)}>Cancel</Button>
          </div>
        }
      >
        <Card bordered={false}>
          <b>Correct my current policy</b>
          <Row
            gutter={16}
            justify="space-between"
            style={{ marginTop: "10px" }}
          >
            <Col span={18}>
              <p>This may result in recalculating past fees</p>
            </Col>
            <Col span={6}>
              <Button type="primary" onClick={handleEditModal}>
                Edit Policy
              </Button>
            </Col>
          </Row>
        </Card>
        <br />
        <Card bordered={false}>
          <b>Create a new policy</b>
          <Row
            gutter={16}
            justify="space-between"
            style={{ marginTop: "10px" }}
          >
            <Col span={18}>
              <p>This will change how fees are calculated going forward</p>
            </Col>
            <Col span={6}>
              <Button type="primary" onClick={handleNewShowManagement}>
                New Policy
              </Button>
            </Col>
          </Row>
        </Card>
      </Modal>
    </div>
  );
};

export default ManagementFees;
